var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmvCardSolid = function SvgEmvCardSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 8A3.75 3.75 0 0 1 6 4.25h12A3.75 3.75 0 0 1 21.75 8v3a.75.75 0 0 1-.75.75H6c-.69 0-1.25.56-1.25 1.25v5.236a.75.75 0 0 1-1.25.559A3.743 3.743 0 0 1 2.25 16V8Zm18 .5a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1 0-1.5h15a.75.75 0 0 1 .75.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.737 13.289a.75.75 0 0 1 .475.948l-1.778 5.333a.75.75 0 0 1-1.423 0l-1.778-5.333a.75.75 0 0 1 1.423-.474l1.066 3.199 1.066-3.2a.75.75 0 0 1 .95-.473ZM11.485 13.289a.75.75 0 0 1 .837.261l1.4 1.867 1.4-1.867a.75.75 0 0 1 1.35.45v5.333a.75.75 0 0 1-1.5 0V16.25l-.65.867a.75.75 0 0 1-1.2 0l-.65-.867v3.083a.75.75 0 0 1-1.5 0V14a.75.75 0 0 1 .513-.711ZM5.972 14a.75.75 0 0 1 .75-.75H9.39a.75.75 0 0 1 0 1.5H7.472v1.167h1.472a.75.75 0 0 1 0 1.5H7.472v1.166H9.39a.75.75 0 0 1 0 1.5H6.722a.75.75 0 0 1-.75-.75V14Z",
    fill: "currentColor"
  })));
};
export default SvgEmvCardSolid;